// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


.custom-phone-input-container .flag-dropdown {
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 0;
  background-color: transparent;
  border: none;
  border-radius: 3px 0 0 3px;
}

.custom-phone-input-container .flag-dropdown:hover,
.custom-phone-input-container .flag-dropdown:focus {
  border-radius: 3px 0 0 3px;
}

.custom-phone-input-container .selected-flag {
  width: 42px;
  height: 100%;
  padding: 0 0 0 8px;
  border-radius: 3px 0 0 3px;
  display: flex;
  align-items: center;
}

.custom-phone-input-container .selected-flag:focus {
  border-radius: 3px 0 0 3px;
}

.custom-phone-input-container .selected-flag .arrow {
  position: relative;
  top: 50%;
  margin-top: -2px;
  left: 20px;
  width: 0;
  height: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 4px solid #555;
}

.custom-phone-input-container .selected-flag .arrow.up {
  border-top: none;
  border-bottom: 4px solid #555;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n\r\n.custom-phone-input-container .flag-dropdown {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  border: none;\r\n  border-radius: 3px 0 0 3px;\r\n}\r\n\r\n.custom-phone-input-container .flag-dropdown:hover,\r\n.custom-phone-input-container .flag-dropdown:focus {\r\n  border-radius: 3px 0 0 3px;\r\n}\r\n\r\n.custom-phone-input-container .selected-flag {\r\n  width: 42px;\r\n  height: 100%;\r\n  padding: 0 0 0 8px;\r\n  border-radius: 3px 0 0 3px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.custom-phone-input-container .selected-flag:focus {\r\n  border-radius: 3px 0 0 3px;\r\n}\r\n\r\n.custom-phone-input-container .selected-flag .arrow {\r\n  position: relative;\r\n  top: 50%;\r\n  margin-top: -2px;\r\n  left: 20px;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 3px solid transparent;\r\n  border-right: 3px solid transparent;\r\n  border-top: 4px solid #555;\r\n}\r\n\r\n.custom-phone-input-container .selected-flag .arrow.up {\r\n  border-top: none;\r\n  border-bottom: 4px solid #555;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
